"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css2 = require("@emotion/css");
var _search = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/search"));
var _searchField = _interopRequireDefault(require("@amzn/meridian-tokens/component/search-field"));
var _button = _interopRequireDefault(require("../button"));
var _icon = _interopRequireDefault(require("../icon"));
var _theme = _interopRequireWildcard(require("../theme"));
var _token = require("./../_utils/token");
var _borderRadius = _interopRequireDefault(require("./../_utils/border-radius"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var state = _ref.state,
    borderRadiusRight = _ref.borderRadiusRight;
  return (0, _css2.css)((0, _defineProperty2["default"])({
    position: "relative",
    height: "100%",
    // When the button is *not* focused, draw a border to the left (when it is
    // focused a focus outline is shown and we don't want the border to render
    // on top of the outline).
    "&:not(:focus):before": {
      content: "''",
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: t("borderStartWidth"),
      backgroundColor: t("borderStartColor", state)
    },
    borderRadius: (0, _borderRadius["default"])(borderRadiusRight, ["topRight", "bottomRight"])
  }, "[dir=\"rtl\"] &", {
    borderRadius: (0, _borderRadius["default"])(borderRadiusRight, ["topLeft", "bottomLeft"])
  }));
}, ["state", "borderRadiusRight"]);
var getOverrideTokens = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var active = _ref2.active;
  var activeColorTokens = {};
  if (active) {
    var fg = t("foregroundColorActive");
    var bgDefault = t("backgroundColorActiveDefault");
    var bgHover = t("backgroundColorActiveHover");
    var bgPressed = t("backgroundColorActivePressed");
    activeColorTokens = {
      buttonForegroundColorIconDefault: fg,
      buttonForegroundColorIconHover: fg,
      buttonForegroundColorIconPressed: fg,
      buttonBackgroundColorIconDefault: bgDefault,
      buttonBackgroundColorIconHover: bgHover,
      buttonBackgroundColorIconPressed: bgPressed
    };
  }
  return _objectSpread({
    buttonFocusOutlineOffset: 1
  }, activeColorTokens);
}, ["active"]);
var SearchButton = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(SearchButton, _React$Component);
  var _super = _createSuper(SearchButton);
  function SearchButton() {
    (0, _classCallCheck2["default"])(this, SearchButton);
    return _super.apply(this, arguments);
  }
  (0, _createClass2["default"])(SearchButton, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var state = props.disabled ? "disabled" : props.active ? "active" : "empty";
      return /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _searchField["default"],
        map: (0, _token.getTokenHelper)("searchFieldSearchButton")
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(_theme["default"], {
          tokens: getOverrideTokens(t, props)
        }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
          type: "icon",
          onClick: props.onClick,
          disabled: props.disabled,
          className: styles(t, {
            state: state,
            borderRadiusRight: props.borderRadiusRight
          }),
          label: props.children
        }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
          tokens: _search["default"]
        })));
      });
    }
  }]);
  return SearchButton;
}(_react["default"].Component);
SearchButton.propTypes = process.env.NODE_ENV !== "production" ? {
  active: _propTypes["default"].bool,
  borderRadiusRight: _propTypes["default"].number,
  children: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
} : {};
var _default = SearchButton;
exports["default"] = _default;